import { UseQueryResult } from '@tanstack/react-query';
import React, { createContext, ReactNode, useContext } from 'react';

export type InfoPaneQueries = {
  comments: {
    useCommentsQuery: () => UseQueryResult<any, unknown>;
    onCommentAdded: (response: any) => void;
  };
  useActivityLogsQuery: () => UseQueryResult<any, unknown>;
};

type FileEntryViewerInfoPanelContextType = {
  infoPanelQueries: InfoPaneQueries;
};

const FileEntryViewerInfoPanelContext = createContext<
  FileEntryViewerInfoPanelContextType | undefined
>(undefined);

type FileEntryViewerInfoPanelProviderProps = {
  infoPanelQueries: InfoPaneQueries;
  children: ReactNode;
};

export const FileEntryViewerInfoPanelProvider = ({
  infoPanelQueries,
  children,
}: FileEntryViewerInfoPanelProviderProps) => {
  return (
    <FileEntryViewerInfoPanelContext.Provider
      value={{
        infoPanelQueries,
      }}
    >
      {children}
    </FileEntryViewerInfoPanelContext.Provider>
  );
};

export function useFileEntryViewerInfoPanel() {
  const store = useContext(FileEntryViewerInfoPanelContext);
  if (!store) {
    throw new Error(
      'useFileEntryViewerInfoPanel must be used within a FileEntryViewerInfoPanelProvider'
    );
  }
  return store;
}
